import ProjectsService from "../../services/projects.service";

const state = {
    projects: [],
    project: [],
    userProject: [],
    projectsOfUser: [],
    isActiveProjectModal: false,
};


const mutations = {
    set_project_list(state, payload) {
        state.projects = payload
    },
    set_project(state, payload) {
        state.project = payload;
    },
    set_project_of_user(state, payload) {
        state.projectsOfUser = payload;
    },
    set_user_project_list(state, payload) {
        state.userProject = payload;
    },
    set_close_open_project_modal(state) {
        state.isActiveProjectModal = !state.isActiveProjectModal;
        if (!state.isActiveProjectModal) {
            state.project = [];
        }
    },
    set_none() {
        console.log("none");
    }

};

const actions = {

    async getProjects({commit}) {
        const projects = await ProjectsService.getProjectsService();
        commit("set_project_list", projects);
        return projects;
    },

    async getProject({commit}, payload) {
        const project = await ProjectsService.getProjectService(payload);
        commit("set_project", project);
        return project;
    },

    async getUserProject({commit}, paylod) {

        const userproject = await ProjectsService.getUserProjectService(paylod);
        commit("set_user_project_list", userproject);
        return userproject;
    },
    async getProjectOfUser({commit}) {
        const projectuser = await ProjectsService.getProjectsOfUserService();
        commit("set_project_of_user",projectuser);
        return projectuser;
    },

    async addUserProject({commit}, payload) {
        const adduser = await ProjectsService.addUserProjectService(payload);
        commit("set_none", adduser);
        return adduser;
    },

    async addProject({dispatch}, payload) {
        const project = await ProjectsService.addProjectService(payload);
        dispatch("getProjects");
        return project;
    },
    /*
    async uploadIcon({dispatch},payload){
        const upload = await ProjectsService.uploadIconService(payload);
        dispatch("getProjects");
        return upload;
    },*/

    async openCloseProjectModal({commit}) {
        commit("set_close_open_project_modal");
    },

    async deleteUser({commit}, {userId, projectId}) {
        const deleteuser = await ProjectsService.deleteUserService(userId,projectId);
        commit("set_none", deleteuser);
        return deleteuser;
    },
    /*    async addUserProject({commit}, {userId, projectId}) {
            console.log(("addusermodule"))
            console.log((userId))
            console.log((projectId));

            const adduser = await ProjectsService.addUserProjectService(userId, projectId);
            commit("set_project", adduser);
            return adduser;
        }*/

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
